import { Tooltip } from "@mui/material";
import { Paperclip, X } from "lucide-react";
import { StyledFileContext, StyledFileName, StyledListFiles } from "./FileContext.styles";
import { Spinner } from "../../../../components/Spinner";
import { ImageContextFile } from "../../AISupportChat.types";

type IFileContext = {
    listImgContext: ImageContextFile[]
    onDeleteImage?: (index?: number) => void
    isLoading: boolean
}

// const mockListImgContext: ImageContextFile[] = [
//   Object.assign(new File(["mock-content-1"], "mock-image-1.png", { type: "image/png" }), { id: "mock-id-1" }),
//   Object.assign(new File(["mock-content-2"], "mock-image-2.jpg", { type: "image/jpeg" }), { id: "mock-id-2" })
// ];

export const FileContext = ({
  listImgContext,
  onDeleteImage,
  isLoading
}: IFileContext) => {
  // useEffect(() => {
  //   console.log("listImgContext");

  // }, [listImgContext]);

  return (
    <StyledListFiles>
      { isLoading 
        ? (
          <Spinner size={ "1rem" }/> 
        )
        : listImgContext.map((img, index) => {
          return (
            <StyledFileContext key={ img.id }>
              <Paperclip size={ "0.875rem" }/>
              <Tooltip title={ img.name }>
                <StyledFileName>{ img.name }</StyledFileName>
              </Tooltip>
              { /* { img.weight } */ }
              <X
                size={ "0.875rem" }
                style={ {
                  cursor: "pointer"
                } }
                onClick={ () => onDeleteImage?.(index)
                }
              />
            </StyledFileContext>
          );
        }) }
    </StyledListFiles>
  );
};
